import React from "react";
import { ThemeToggle as SharedThemeToggle } from "@packages/ui";
import { useTheme } from "../hooks/useTheme";

interface ThemeToggleProps {
  compact?: boolean;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ compact = false }) => {
  const { mode, setMode } = useTheme();
  return <SharedThemeToggle compact={compact} mode={mode} setMode={setMode} />;
};

export default ThemeToggle;
